import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { caseFileLogAPI } from '../api/api';
import { formatDateForDisplay } from '../utils/dateUtils';
import './CaseFileLogs.css';

const CaseFileLogs = () => {
  const { token } = useAuth();
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (token) {
      loadLogs();
    }
  }, [token]);

  const loadLogs = async () => {
    setLoading(true);
    try {
      const data = await caseFileLogAPI.getAll();
      setLogs(data || []);
      setFilteredLogs(data || []);
    } catch (error) {
      console.error('Error loading case file logs:', error);
      if (error.response?.status === 403) {
        alert('Bu sayfaya erişim yetkiniz yok. Sadece admin kullanıcılar logları görüntüleyebilir.');
      } else {
        alert('Loglar yüklenirken hata oluştu: ' + (error.response?.data?.message || error.message));
      }
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    // UTC+3 (Istanbul) timezone için formatDateForDisplay kullan
    return formatDateForDisplay(dateString);
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase().trim();
    setSearchTerm(term);
    
    if (!term) {
      setFilteredLogs(logs);
      return;
    }

    const filtered = logs.filter((log) => {
      const foyNo = String(log.CaseFileFoyNo || log.caseFileFoyNo || '').toLowerCase();
      const userName = String(log.UserName || log.userName || '').toLowerCase();
      
      return foyNo.includes(term) || userName.includes(term);
    });
    
    setFilteredLogs(filtered);
  };

  if (loading) {
    return <div className="logs-container"><div className="loading">Yükleniyor...</div></div>;
  }

  return (
    <div className="logs-container">
      <div className="page-header">
        <h1>Dosya Logları</h1>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Dosya (Föy No) veya Kullanıcı adı ile ara..."
          value={searchTerm}
          onChange={handleSearch}
          className="search-input"
        />
        {searchTerm && (
          <span className="search-results">
            {filteredLogs.length} sonuç bulundu
          </span>
        )}
      </div>

      <div className="logs-table-container">
        {logs.length === 0 ? (
          <div className="no-data">Henüz log kaydı bulunmamaktadır.</div>
        ) : filteredLogs.length === 0 ? (
          <div className="no-data">Arama kriterlerinize uygun log kaydı bulunamadı.</div>
        ) : (
          <table className="logs-table">
            <thead>
              <tr>
                <th>Tarih</th>
                <th>Kullanıcı</th>
                <th>Dosya (Föy No)</th>
                <th>İşlem</th>
                <th>Alan</th>
                <th>Eski Değer</th>
                <th>Yeni Değer</th>
                <th>Açıklama</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map((log) => (
                <tr key={log.Id || log.id}>
                  <td>{formatDateTime(log.ActionDate || log.actionDate)}</td>
                  <td>{log.UserName || log.userName || '-'}</td>
                  <td>{log.CaseFileFoyNo || log.caseFileFoyNo || '-'}</td>
                  <td>
                    <span className={`action-badge action-${(log.Action || log.action || '').toLowerCase()}`}>
                      {log.Action || log.action || '-'}
                    </span>
                  </td>
                  <td>
                    <strong>{log.FieldName || log.fieldName || '-'}</strong>
                    {log.Description && log.Description !== '-' && (
                      <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                        {log.Description || log.description}
                      </div>
                    )}
                  </td>
                  <td className="old-value">
                    {(() => {
                      const oldVal = log.OldValue || log.oldValue;
                      if (!oldVal || oldVal === '-' || oldVal === 'null' || oldVal === 'undefined') {
                        return log.Action === 'Create' || log.action === 'Create' ? '-' : 'Boş';
                      }
                      return oldVal;
                    })()}
                  </td>
                  <td className="new-value">
                    {(() => {
                      const newVal = log.NewValue || log.newValue;
                      if (!newVal || newVal === '-' || newVal === 'null' || newVal === 'undefined') {
                        return 'Boş';
                      }
                      return newVal;
                    })()}
                  </td>
                  <td style={{ fontSize: '12px', color: '#666' }}>
                    {log.Description && log.Description !== '-' ? log.Description : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default CaseFileLogs;

